// eslint-disable-next-line import/prefer-default-export
export const SEVERITY_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
} as const;
